export const environment = {
  production: true,
  buildId: '3339694020021641',
  configFile: 'config.json',
};
